import { render, staticRenderFns } from "./NuevoChofer.vue?vue&type=template&id=148fa56f"
import script from "./NuevoChofer.vue?vue&type=script&lang=js"
export * from "./NuevoChofer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports